exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modify_box[data-v-240cbb3e]{\n  width: 52px;\n  margin-bottom: 10px;\n}\n", ""]);

// exports
